import { useState, useRef, useEffect } from "react";
import { Col, Row, Form, Spinner } from "react-bootstrap";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  BlockContentControls,
  ButtonCommon,
  ChipsControl,
  InputTextForm,
  InputText,
  ModalActionMessage,
  SelectGender,
  SelectSizeGuideType,
  SizesForm,
  SuggestionWidget,
} from "../../../common";
import {
  ISizeModel,
  IBodyPart,
  ISizeModelMeasure,
  ISizeGuide,
  E_ClothesType,
  E_GenderType,
  E_BodyPart,
} from "../../../common/types";
import { SizeGuideServices } from "../../../../services";
import "./NewSizeGuide.css";
import { FormattedMessage, useIntl } from "react-intl";
import { Tag } from "primereact/tag";
import TooltipAlias from "../../../common/components/TooltipAlias";
import { Tools } from "../../../../misc";

const NewSizeGuide = (props: any) => {
  const { state } = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const intl = useIntl();

  const clothesType = parseInt(
    searchParams.get("clothesType") || E_ClothesType.TOP.toString()
  );
  const [clothesTypeSelect, setClothesTypeSelect] = useState(
    parseInt(searchParams.get("clothesType") || E_ClothesType.TOP.toString())
  );
  const gender = parseInt(
    searchParams.get("gender") || E_GenderType.FEMALE.toString()
  );
  const [genreSelect, setGenreSelect] = useState(
    parseInt(searchParams.get("gender") || E_GenderType.FEMALE.toString())
  );
  const unique = searchParams.get("isUnique") === "false" ? false : true;
  const [uniqueSelect, setUniqueSelect] = useState(
    searchParams.get("isUnique") === "false" ? false : true
  );
  const [cupSelect, setCupSelect] = useState<any[]>([]);
  const [sizeGuideName, setSizeGuideName] = useState("");
  const [formSizes, setFormSizes] = useState<ISizeModel[]>([]);
  const [createProductGuideSelected, setCreateProductGuide] = useState(
    Tools.UserMustCreateRelatedCode()
  );
  const [
    productReferenceCodeDefaultValue,
    setProductReferenceCodeDefaultValue,
  ] = useState("");
  const [productReferenceCode, setProductReferenceCode] = useState("");
  const [nameError, setNameError] = useState("");
  const [otherReference, setOtherReference] = useState<string[]>(
    props.state &&
      props.state.OtherReference &&
      props.state.OtherReference.length > 0
      ? props.state.OtherReference
      : []
  );
  const [showCustomWarning, setShowCustomWarning] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    if (isSaving) {
      document.body.style.cursor = "wait";
    } else {
      document.body.style.cursor = "default";
    }
    return () => {
      document.body.style.cursor = "default";
    };
  }, [isSaving]);

  const hasEmptyMeasureName = () => {
    return formSizes.some(
      (size) => size.Name.trim().length === 0 || size.Measures.length === 0
    );
  };

  const getBodyParts = (type: number) => {
    let bodyParts: Array<IBodyPart> = new Array<IBodyPart>();

    try {
      if (type === E_ClothesType.TOP) {
        bodyParts.push({
          Id: E_BodyPart.CHEST,
          Name: intl.formatMessage({
            id: "edit-size-guide-contornoBusto",
            defaultMessage: "Contorno de busto",
          }),
        });
        bodyParts.push({
          Id: E_BodyPart.WAIST,
          Name: intl.formatMessage({
            id: "edit-size-guide-contornoCintura",
            defaultMessage: "Contorno de cintura",
          }),
        });
        bodyParts.push({
          Id: E_BodyPart.HIP,
          Name: intl.formatMessage({
            id: "edit-size-guide-contornoCadera",
            defaultMessage: "Contorno de cadera",
          }),
        });
      } else {
        if (type === E_ClothesType.BOTTOM) {
          bodyParts.push({
            Id: E_BodyPart.WAIST,
            Name: intl.formatMessage({
              id: "edit-size-guide-contornoCintura",
              defaultMessage: "Contorno de cintura",
            }),
          });
          bodyParts.push({
            Id: E_BodyPart.HIP,
            Name: intl.formatMessage({
              id: "edit-size-guide-contornoCadera",
              defaultMessage: "Contorno de cadera",
            }),
          });
          bodyParts.push({
            Id: E_BodyPart.LEG,
            Name: intl.formatMessage({
              id: "edit-size-guide-altoTotal",
              defaultMessage: "Alto total",
            }),
          });
        } else {
          if (type === E_ClothesType.ENTIRE) {
            bodyParts.push({
              Id: E_BodyPart.CHEST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoBusto",
                defaultMessage: "Contorno de busto",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.WAIST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoCintura",
                defaultMessage: "Contorno de cintura",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.HIP,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoCadera",
                defaultMessage: "Contorno de cadera",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.LEG,
              Name: intl.formatMessage({
                id: "edit-size-guide-altoTotal",
                defaultMessage: "Alto total",
              }),
            });
          } else if (type === E_ClothesType.SHOES) {
            // For shoes
            bodyParts.push({
              Id: E_BodyPart.FOOT,
              Name: intl.formatMessage({
                id: "edit-size-guide-pieIzquierdo",
                defaultMessage: "Largo de Pie",
              }),
            });
            // bodyParts.push({
            //   Id: E_BodyPart.FOOT,
            //   Name: intl.formatMessage({
            //     id: "edit-size-guide-pieDerecho",
            //     defaultMessage: "Pie Derecho",
            //   }),
            // });
          } else {
            bodyParts.push({
              Id: E_BodyPart.CHEST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoBusto",
                // defaultMessage: "Contorno de busto",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.UNDERBUST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoBajoBusto",
                // defaultMessage: "Contorno de bajo busto",
              }),
            });
          }
        }
      }
    } catch (error) {
      console.log("GetBodyParts", error);
    }

    return bodyParts;
  };

  const getSizes = (partsBody: IBodyPart[], FormSizes: ISizeModel[] | []) => {
    let aSizes: Array<ISizeModel> = new Array<ISizeModel>();
    let newSize: ISizeModel;

    try {
      if (FormSizes && FormSizes.length > 0) {
        aSizes = [...FormSizes];
      } else {
        newSize = {
          Id: 0,
          Order: 1,
          Name: "",
          Measures: new Array<ISizeModelMeasure>(),
        };

        partsBody.forEach((item: IBodyPart, indexBodyPart: number) => {
          let RowMeasure: ISizeModelMeasure = {
            Id: item.Id,
            From: 0,
            ErrorFrom: false,
            To: 0,
            ErrorTo: false,
            IsSuccess: false,
            BodyPart: item,
          };

          newSize.Measures.push(RowMeasure);
        });

        aSizes.push(newSize);

        setFormSizes(aSizes);
      }
    } catch (error) {
      console.log("GET SIZES", error);
    }

    return aSizes;
  };

  const onCheckProductGuideCreate = (value: any) => {
    try {
      setCreateProductGuide(value);

      if (value) {
        setProductReferenceCodeDefaultValue(
          `${sizeGuideName?.substr(0, 33).split(" ").join("-")}-rs-${Number(
            new Date()
          )}`
        );
        setProductReferenceCode(
          `${sizeGuideName?.substr(0, 33).split(" ").join("-")}-rs-${Number(
            new Date()
          )}`
        );
      } else {
        setProductReferenceCodeDefaultValue("");
        setProductReferenceCode("");
      }
    } catch (error) {
      console.log("ERROR ", error);
    }
  };

  const contentAttibrutes = () => {
    return (
      <>
        <Form>
          <InputTextForm
            Label={"size-guide-guideName"}
            Placeholder={"size-guide-enterGuideName"}
            MaxLength={100}
            SuscribedChange={(value: string) => {
              setSizeGuideName(value);
              if (value.length < 5) {
                setNameError(
                  intl.formatMessage({
                    id: "size-guide-nameError",
                    defaultMessage: "Se necesitan por lo menos 5 caracteres",
                  })
                );
              } else {
                setNameError("");
              }

              if (Tools.UserMustCreateRelatedCode()) {
                if (value) {
                  setProductReferenceCodeDefaultValue(
                    `${value
                      ?.trim()
                      .substr(0, 35)
                      .split(" ")
                      .join("-")}-${Number(new Date())}`
                  );
                  setProductReferenceCode(
                    `${value
                      ?.trim()
                      .substr(0, 35)
                      .split(" ")
                      .join("-")}-${Number(new Date())}`
                  );
                } else {
                  setProductReferenceCodeDefaultValue("");
                  setProductReferenceCode("");
                }
              }
            }}
          />
          {nameError && <p className="text-danger">{nameError}</p>}
          <SelectSizeGuideType
            Label={intl.formatMessage({
              id: "ready-size-clothing-type",
              defaultMessage: "Tipo de prenda",
            })}
            ClassGroup={"mt-3"}
            DefaultValue={clothesType}
            SuscribedChange={(value: number) => setClothesTypeSelect(value)}
          />
          <SelectGender
            Label="ready-size-gender"
            ClassGroup={"mt-3"}
            DefaultValue={gender}
            Disabled={clothesTypeSelect === E_ClothesType.BRASSIERE}
            SuscribedChange={(value: number) => setGenreSelect(value)}
          />
          <Form.Group
            className={`justify-content-center mt-3 ${
              clothesTypeSelect !== E_ClothesType.BRASSIERE
                ? "d-none"
                : "d-block"
            }`}
          >
            <ChipsControl
              Title={intl.formatMessage({
                id: "size-guide-cups",
                defaultMessage: "Copas",
              })}
              onChipChange={(e: any) => handlerCupChange(e)}
            />
          </Form.Group>
          <Form.Group
            className={`justify-content-center mt-3 ${
              clothesTypeSelect !== E_ClothesType.BRASSIERE
                ? "d-block"
                : "d-none"
            }`}
          >
            <Form.Check
              type="checkbox"
              label={intl.formatMessage({
                id: "ready-size-unique-size",
                defaultMessage: "Talle único",
              })}
              onChange={(e) => setUniqueSelect(e.target.checked)}
              defaultChecked={unique}
              disabled={clothesTypeSelect === E_ClothesType.BRASSIERE}
            />
          </Form.Group>
          <Form.Group as={Row} className={`justify-content-center mt-3`}>
            <Col xs={4}>
              <Form.Check
                type="checkbox"
                label={intl.formatMessage({
                  id: "size-guide-createGuideProduct",
                  defaultMessage: "Crear producto guía",
                })}
                defaultChecked={Tools.UserMustCreateRelatedCode()}
                onChange={(e) => onCheckProductGuideCreate(e.target.checked)}
                disabled={Tools.UserMustCreateRelatedCode()}
              />
            </Col>
            <Col xs={8}>
              <InputText
                Label={""}
                Placeholder={intl.formatMessage({
                  id: "size-guide-enterProductCode",
                  defaultMessage: "Ingresar el código del producto a generar",
                })}
                MaxLength={50}
                ClassName="ms-auto w-75 text-start"
                Disabled={
                  !createProductGuideSelected ||
                  Tools.UserMustCreateRelatedCode()
                }
                DefaultValue={
                  !createProductGuideSelected
                    ? ""
                    : productReferenceCodeDefaultValue
                }
                SuscribedChange={(value: string) =>
                  setProductReferenceCode(value)
                }
              />
            </Col>
          </Form.Group>
        </Form>
      </>
    );
  };

  const contentSizes = () => {
    return (
      <>
        <SizesForm
          BodyParts={getBodyParts(clothesTypeSelect)}
          Elements={getSizes(getBodyParts(clothesTypeSelect), formSizes)}
          ClothesType={clothesTypeSelect}
          Cups={cupSelect}
          SucribeChanges={(e: ISizeModel[]) => handlerChangeForm(e)}
          ValidateSizes={() => hasEmptyMeasureName()}
          showCustomWarning={showCustomWarning}
        />
      </>
    );
  };

  const handlerChangeForm = (Elements: ISizeModel[]) => {
    setFormSizes(Elements);
  };

  const handlerCupChange = (e: any) => {
    setCupSelect(e);
  };

  const onClickCancelar = () => {
    navigate(-1);
  };

  const onClickSave = async () => {
    setIsSaving(true); // Set isSaving to true when saving starts

    let SizeGuide: ISizeGuide;
    let qErrors: number = 0;

    const hasEmptyMeasures = hasEmptyMeasureName();
    if (hasEmptyMeasures) {
      console.log("Algunos talles tienen valores vacios");
    }

    if (qErrors !== 0 || hasEmptyMeasures) {
      setShowCustomWarning(true);
      setIsSaving(false);
      return;
    }

    try {
      if (sizeGuideName.length < 5) {
        qErrors++;
        setNameError("Nombre necesita por lo menos 5 caracteres");
      } else {
        setNameError("");
      }

      if (
        (!uniqueSelect && formSizes.length < 2) ||
        (uniqueSelect && (formSizes.length < 1 || formSizes[0].Name === ""))
      ) {
        qErrors++;
        console.log("Error: Sizes must have at least 1 letter");
      }

      if (createProductGuideSelected && productReferenceCode.length < 10) {
        qErrors++;
        console.log("Error: ProductReference must have at least 10 letters");
      }

      if (qErrors !== 0) {
        setIsSaving(false);
        return;
      }

      SizeGuide = {
        Id: 0,
        Name: sizeGuideName,
        UnfixedLimits: false,
        Cups: cupSelect,
        TypeSizeGuide: { Id: clothesTypeSelect, Name: "" },
        Gender: { Id: genreSelect, Name: "" },
        IsUnique: uniqueSelect,
        Sizes: formSizes,
        ProductReference: createProductGuideSelected
          ? productReferenceCode
          : "",
        OtherReference: [],
        Enabled: true,
      };

      console.log("SAVE SIZE GUIDE ITEM", SizeGuide);

      // Call the API to save the size guide
      const sizeGuideResponse = await SizeGuideServices.PostSizeGuide(
        SizeGuide
      );

      if (sizeGuideResponse && sizeGuideResponse.Status === 200) {
        if (sizeGuideResponse.Content) {
          setShowModal(true);
        } else {
          console.log("SAVE SIZE GUIDE RESPONSE ERROR", sizeGuideResponse);
        }
      } else {
        console.log("SAVE SIZE GUIDE RESPONSE ERROR", sizeGuideResponse);
      }

      setShowCustomWarning(false);
    } catch (error) {
      console.log("SAVE SIZE GUIDE", error);
    } finally {
      setIsSaving(false); // Stop the spinner when the save process is complete
    }
  };

  const onHideModal = () => {
    setShowModal(false);
    navigate(-1);
  };

  const clothesImages: { [key: string]: any } = {
    TOP: {
      FEMALE: {
        es: "img/topclothingfemes.png",
        en: "img/topclothingfemen.png",
        pt: "img/topclothingfempt.png",
      },
      MALE: {
        es: "img/topclothingmalees.png",
        en: "img/topclothingmaleen.png",
        pt: "img/topclothingmalept.png",
          },
          UNISEX: {
              es: "",
              en: "",
              pt: "",
          },
          UNKNOW: {
              es: "",
              en: "",
              pt: "",
          }
    },
    BOTTOM: {
      FEMALE: {
        es: "img/bottomclothingfemes.png",
        en: "img/bottomclothingfemen.png",
        pt: "img/bottomclothingfempt.png",
      },
      MALE: {
        es: "img/bottomclothingmalees.png",
        en: "img/bottomclothingmaleen.png",
        pt: "img/bottomclothingmalept.png",
        },
        UNISEX: {
            es: "",
            en: "",
            pt: "",
        },
        UNKNOW: {
            es: "",
            en: "",
            pt: "",
        }
    },
    ENTIRE: {
      FEMALE: {
        es: "img/fullclothingfemes.png",
        en: "img/fullclothingfemen.png",
        pt: "img/fullclothingfempt.png",
      },
      MALE: {
        es: "img/fullclothingmalees.png",
        en: "img/fullclothingmaleen.png",
        pt: "img/fullclothingmale.png",
        },
        UNISEX: {
            es: "",
            en: "",
            pt: "",
        },
        UNKNOW: {
            es: "",
            en: "",
            pt: "",
        }
    },
    BRASSIERE: {
      FEMALE: {
        es: "img/brassieres.png",
        en: "img/brassieren.png",
        pt: "img/brassierpt.png",
      },
      MALE: {
        es: "",
        en: "",
        pt: "",
        },
        UNISEX: {
            es: "",
            en: "",
            pt: "",
        },
        UNKNOW: {
            es: "",
            en: "",
            pt: "",
        }
    },
    SHOES: {
      FEMALE: {
        es: "",
        en: "",
        pt: "",
      },
      MALE: {
        es: "",
        en: "",
        pt: "",
        },
        UNISEX: {
            es: "",
            en: "",
            pt: "",
        },
        UNKNOW: {
            es: "",
            en: "",
            pt: "",
        }
    },
  };

  const clothesTypeKey = E_ClothesType[clothesTypeSelect];
  const genderTypeKey = E_GenderType[genreSelect];

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setInputValue(value);
  };

  const renderInputs = () => {
    if (!otherReference) return null;

    // Split the pasted data into individual items
    let items = otherReference;

    // Filter items based on the inputValue
    let filteredItems = items.filter((item: any) =>
      item.toLowerCase().includes(inputValue.toLowerCase())
    );

    // Render a Tag for each filtered item
    return (
      <div className="tag-container">
        {filteredItems.map((item: any, index: any) => (
          <div key={index} className="tag-item">
            <Tag>
              <div className="flex align-items-center gap-2 editsizeguide-alias-tag">
                <span className="text-base">{item}</span>
                <i
                  className="pi pi-times text-xs"
                  onClick={() => handleTagDelete(index)}
                ></i>
              </div>
            </Tag>
          </div>
        ))}
      </div>
    );
  };

  const handleTagDelete = (indexToDelete: any) => {
    // Get a copy of the current items array
    let newItems = [...otherReference];

    // Remove the item at the specified index
    newItems.splice(indexToDelete, 1);

    // Update the state with the new data
    setOtherReference(newItems);
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const aliasReference = [...otherReference];

      const pastedText = clipboardData.getData("text/plain");

      let updatedData = pastedText; // Concatenate new data with existing data

      let elementsCopied = updatedData.split("\r\n");

      // Remove the last element if it's empty
      if (
        elementsCopied.length > 0 &&
        elementsCopied[elementsCopied.length - 1] === ""
      ) {
        elementsCopied.pop();
      }

      elementsCopied = elementsCopied.filter(Boolean); // Remove any empty elements

      elementsCopied.forEach((element) => {
        if (element.split("\t").length) {
          element.split("\t").forEach((item) => {
            if (item.split(",").length) {
              item.split(",").forEach((itemComma) => {
                if (itemComma) aliasReference.push(itemComma);
              });
            } else {
              if (item) aliasReference.push(item);
            }
          });
        } else {
          if (element) aliasReference.push(element);
        }
      });

      setOtherReference(aliasReference);

      // Reset the input after pasting
      setInputValue(""); // Set the input value to blank
    }
  };

  const handleDocumentClick = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setIsClicked(false);
    }
  };

  const handleClick = () => {
    setIsClicked(true);
  };

  const contentAlias = () => {
    return (
      <>
        <div>
          <div>
            <div
              ref={divRef}
              onPaste={handlePaste}
              onClick={handleClick}
              className={`editsizeguide-alias-cp ${isClicked ? "clicked" : ""}`}
            >
              <FormattedMessage
                id="ready-size-paste"
                defaultMessage="Pega aquí tus alias"
              />
            </div>
            <p>
              <FormattedMessage
                id="ready-size-search-buscar"
                defaultMessage="Buscar"
              />
            </p>
            <input
              type="text"
              placeholder="Ej: Guia-Superior-Masculino"
              className="editsizeguide-custom-alias-input"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
          <div
            className="tag-container"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            {renderInputs()}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Row>
        <Col>
          <p className="font-fitprenda-title-crud">
            <FormattedMessage
              id="edit-size-guide-main-data"
              defaultMessage="Datos principales"
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={7} className="new-size-guide-block-content-control-main-info">
          <BlockContentControls children={contentAttibrutes()} />
        </Col>
        <Col xs={2} className="new-size-recommendation-main-info">
          <SuggestionWidget
            description={
              <FormattedMessage id="edit-size-guide-widget-use-name" />
            }
            title={<FormattedMessage id="edit-size-guide-widget-use-title" />}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <p className="font-fitprenda-title-crud">
            {" "}
            <FormattedMessage
              id="edit-size-guide-sizes-measures"
              defaultMessage="Talles y medidas"
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="font-fitprenda-subtitle-crud">
          <p>
            <FormattedMessage
              id="edit-size-guide-enterMeasurements"
              defaultMessage="Ingresa en cada campo las {boldText} de la siguiente forma: desde - hasta."
              values={{
                boldText: (
                  <b>
                    <FormattedMessage
                      id="edit-size-guide-bodyMeasurements"
                      defaultMessage="medidas corporales"
                    />
                  </b>
                ),
              }}
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col
          xs={9}
          className="new-size-guide-block-content-control-sizes-measures"
        >
          <BlockContentControls paddingX={5} children={contentSizes()} />
          <Row className="mt-4">
            <Col>
              <p className="font-fitprenda-title-crud">
                <FormattedMessage
                  id="ready-size-edit-size-guide-other-codes"
                  defaultMessage="Agregar otras codificaciónes"
                />
              </p>
            </Col>
          </Row>
          <Row>
            <Col className="font-fitprenda-subtitle-crud">
              <p>
                <FormattedMessage
                  id="ready-size-edit-size-guide-other-codes-exp"
                  defaultMessage="Ingresa en cada campo las {boldText} de la siguiente forma: desde - hasta."
                  values={{
                    boldText: (
                      <b>
                        <FormattedMessage
                          id="edit-size-guide-bodyMeasurements"
                          defaultMessage="medidas corporales"
                        />
                      </b>
                    ),
                  }}
                />
              </p>
              <TooltipAlias />
            </Col>
          </Row>
          <Row>
            {/* Componente de Talles Contornos y alto total */}
            <Col xs={12}>
              <BlockContentControls paddingX={5} children={contentAlias()} />
            </Col>
          </Row>
        </Col>
        <Col xs={2} className="new-size-recommendation-sizes-measures">
          <SuggestionWidget
            styleClass="mb-2"
            title={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage id="edit-size-guide-widget-use-title" />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-contornoBusto"
                  defaultMessage="Contorno busto"
                />
              )
            }
            description={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage
                  id="edit-size-guide-thinkBodyMeasurements"
                  defaultMessage="Pensar en Medidas corporales"
                />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-bustContour"
                  defaultMessage="Todo el contorno rodeando la espalda, justo en el medio del busto."
                />
              )
            }
          />
          <SuggestionWidget
            title={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage id="edit-size-guide-widget-use-title" />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-bajoBusto"
                  defaultMessage="Bajo busto"
                />
              )
            }
            description={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage
                  id="edit-size-guide-considerElasticity"
                  defaultMessage="Tener en cuenta la elasticidad de la prenda"
                />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-bustEndContour"
                  defaultMessage="Contorno del cuerpo justo abajo de donde termina el busto."
                />
              )
            }
          />
        </Col>
        <Col>
          {clothesTypeSelect && genreSelect ? (
            <img
              src={
                clothesImages[clothesTypeKey][genderTypeKey][
                  props.selectedLanguage
                ]
              }
              alt={""}
              width={280}
              className="size-guide-images"
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row className="mt-3 size-guide-buttons-container">
        <Col xs={1} className="new-size-guide-button">
          <ButtonCommon
            label={
              <FormattedMessage
                id="ready-size-Cancelar"
                defaultMessage="Cancelar"
              />
            }
            isOutline={true}
            eventClick={() => onClickCancelar()}
          />
        </Col>
        <Col xs={1} className="new-size-guide-button d-flex align-items-center">
          {/* Guardar Button */}
          <ButtonCommon
            label={intl.formatMessage({
              id: "ready-size-Guardar",
              defaultMessage: "Guardar",
            })}
            isOutline={false}
            eventClick={() => onClickSave()}
            disabled={isSaving} // Disable button while saving
          />

          {/* Spinner shown when saving */}
          {isSaving && (
            <div className="">
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
        </Col>
      </Row>
      <ModalActionMessage
        Title={"¡Guía creada con éxito!"}
        Show={showModal}
        OnModalClose={onHideModal}
      />
      <br />
    </>
  );
};

export default NewSizeGuide;
